export interface Translation {
  id: number;
  locale: string;
  text: string;
}
export enum LegalInfoPolicyType {
  PRIVACY_POLICY = "PRIVACY_POLICY",
  COMMUNICATIONS_POLICY = "COMMUNICATIONS_POLICY",
}

export interface LegalInfo {
  id: number;
  property: string;
  hotelTicker: string;
  translations: Translation[];
}
